import { useMemo } from 'react';
import type { UserRole } from '@insio/shared-types';
import { useEnumTranslation } from '@/hooks/useEnumTranslation';

/**
 * The given roles as Select options with label and description; no permission filtering, e.g. an
 * API key's roles.
 */
export function useRoleLabelOptions(roles: readonly UserRole[]) {
  const tRole = useEnumTranslation('userRole');
  const tDescription = useEnumTranslation('userRoleDescription');
  return useMemo(
    () => roles.map(role => ({ value: role, label: tRole(role), description: tDescription(role) })),
    [roles, tRole, tDescription]
  );
}
